var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTwitter = function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.648 4.312H9.28l3.71 4.943 4.649-4.943h2.655l-6.125 6.513 5.602 7.463 1.05 1.4H15.19l-4.152-5.532-5.202 5.532H3.18l6.678-7.102-5.16-6.874zm12.24 13.976L6.448 5.712h2.134l9.44 12.576z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTwitter;